export default {
	promoId: '_empty_',
	userId: '',
	intoCart: ''
};
